module.exports = __webpack_public_path__ + "img/mas.d6a84ed3.png";